import { Route, Routes } from 'react-router-dom';
import './App.css';
import Success from './components/successpage/Success';
import Exhibition from './pages/exhibition/exhibition';
import Nominate from './pages/nominate/nominate';
import NominateSuccess from './pages/nominateSuccess/NominateSuccess';
import Participate from './pages/participate/participate';
import Payment from './pages/payment/Payment';
import Register from './pages/register/register';


function App() {
  return (
    <Routes>
      <Route exact path='/' element={<Payment />}/>
      <Route path='/sucsessful' element={<Success />}/>
      <Route path='/participate' element={<Participate />}/>
      <Route path='/nominate' element={<Nominate />}/>
      <Route path='/exhibition' element={<Exhibition />}/>
      <Route path='/register' element={<Register />}/>
      <Route path='/nominate-success' element={<NominateSuccess />}/>
    </Routes>
  );
}

export default App;
